import { API_BASE_URL, APP_ROLE } from '@/config/env'
import { SOCKET_EVENTS } from '@/entities/order/socket/events'
import { joinRestaurantRoom } from '@/entities/order/socket/joins'
import { useRestaurantStore } from '@/entities/restaurant/model/useRestaurantStore'
import { useRestaurantOrdersStore } from '@/features/restaurant-orders/model/useRestaurantOrdersStore'
import { connectSocket, off, on } from '@/shared/socket/socketClient'
import { useAuthStore } from '@/stores/auth'

let unsubscribeNewOrder = null
let joinedRestoId = null

async function handleNewOrder({ order_id: orderId }) {
  const ordersStore = useRestaurantOrdersStore()
  await ordersStore.fetchOrderList()

  if (!orderId) {
    return
  }

  const selectedId = ordersStore.selectedOrderId
  if (selectedId && String(selectedId) === String(orderId)) {
    await ordersStore.loadSelectedOrder(orderId)
  }
}

export async function startRestaurantRealtime() {
  if (APP_ROLE !== 'restaurant' || !API_BASE_URL) {
    return
  }

  const authStore = useAuthStore()
  if (!authStore.isLoggedIn) {
    return
  }

  const restaurantStore = useRestaurantStore()
  await restaurantStore.fetchStaffProfile()

  const restoId = restaurantStore.restaurantId
  if (!restoId) {
    console.warn('[realtime] restaurant id missing, skip socket join')
    return
  }

  try {
    await connectSocket()
  } catch (error) {
    console.warn('[realtime] socket connect failed', error)
    return
  }

  if (joinedRestoId !== restoId) {
    joinRestaurantRoom(restoId)
    joinedRestoId = restoId
  }

  if (!unsubscribeNewOrder) {
    on(SOCKET_EVENTS.restaurant.NEW_ORDER, handleNewOrder)
    unsubscribeNewOrder = () => off(SOCKET_EVENTS.restaurant.NEW_ORDER, handleNewOrder)
  }
}

export function stopRestaurantRealtime() {
  if (unsubscribeNewOrder) {
    unsubscribeNewOrder()
    unsubscribeNewOrder = null
  }
  joinedRestoId = null
}
